/**
 配置管理--非直连设备列表
 */
import React, { Component } from "react";
import { Modal } from "antd";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
import RefreshGrid from "../../../utils/refreshGrid";
import fetchHandler from "../../../fetch/fetchHandler";
import {
  prefixFile,
  getCityList,
  getUpdateTypeList,
  getFrameWorkList,
  getUnDirectConnectDeviceApi,
} from "@/fetch/fetchApi";
import { useAuth } from "@/utils/utils";
import StubParamsConfig from "./stubParamsConfig";
import FrameWorkUpdate from "./frameWorkUpdate";
import StubStatusLog from "./stubStatusLog";

@connect((state) => state)
class UnDirectConnectDevice extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      formConfig: null,
      tableConfig: null,
      tableParam: {
        deviceId: "", //设备编号
        areaId: "", //地区
        modelNo: "", //设备型号
        version: "", //固件信息
      },
    };
  }
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
      tableConfig: this.initTableConfig(),
    });
  }
  componentDidMount() {
    this.fetchApi(this.state.tableParam);
  }
  //初始化表单
  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入设备编号",
          param: {
            name: "deviceId",
            type: "string",
          },
          defaultValue: "",
          labelName: "设备编号",
          required: false,
        },
        // {
        //   type: "areaPicker",
        //   isPickArea: !0,
        //   placeholder: "请选择地区",
        //   pickOnSelect: true,
        //   param: {
        //     name: "areaId", // 与form表单绑定的参数名
        //     type: "array",
        //   },
        //   required: !1,
        //   labelName: "地区",
        //   className: "allshow",
        //   sourceApi: getCityList,
        //   mapKey: {
        //     label: "label",
        //     value: "value",
        //     children: "children",
        //   },
        //   defaultValue: [],
        // },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "areaId",
            type: "array",
          },
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
          allowClear: true,
          sourceApi: getCityList,
          mapKey: {
            label: "title",
            value: "value",
            children: "children",
          },
          // onChange: this.handleAreaChange,
          // data: this.state.areaOptions,
          // defaultValue: [],
        },
        {
          type: "input",
          placeholder: "请输入设备型号",
          param: {
            name: "modelNo",
            type: "string",
          },
          defaultValue: "",
          labelName: "设备型号",
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入固件信息",
          param: {
            name: "version",
            type: "string",
          },
          defaultValue: "",
          labelName: "固件信息",
          required: false,
        },
        // {
        //   type: "inputGroup",
        //   isArray: true,
        //   inputGroup: [
        //     {
        //       type: "select",
        //       placeholder: '固件型号',
        //       width: "95px",
        //       param: {
        //         name: "version",
        //         type: "string",
        //       },

        //       labelName: '固件信息',
        //       dataApi: { api: getUpdateTypeList, loaded: !1, addAll: true },
        //       required: false,
        //       onChange: async (value, form) => {
        //         form.setFieldsValue({
        //           frameWork: "",
        //           version: value,
        //         });
        //         fetchHandler(getFrameWorkList, {
        //           version: value,
        //         }).then((res) => {
        //           const finalData = res.data;
        //           finalData.unshift("全部");
        //           this.setState(
        //             {
        //               xhList: finalData.map((v) => {
        //                 return {
        //                   text: v,
        //                   value: v,
        //                 };
        //               }),
        //             },
        //             () => {
        //               this.setState({
        //                 formConfig: this.initFormConfig(),
        //               });
        //             },
        //           );
        //         });
        //       },
        //     },
        //     {
        //       type: "select",
        //       placeholder: '固件版本',
        //       width: "95px",
        //       param: {
        //         name: "version",
        //         type: "string",
        //       },
        //       options: this.state.xhList,
        //       required: false,
        //     },
        //   ],
        // },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("010801")
              ? {
                  btnType: "submit",
                  text: "查询",
                }
              : "",
            useAuth("010802")
              ? {
                  btnType: "button",
                  text: "导出",
                  handler: (e, param) => {
                    this.exportData(param);
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !0, // 设置为false不触发加载grid
      defaultParams: {
        ...this.state.tableParam,
      },
      context: this,
      tableKey: "unDirectConnectDeviceTable",
      tablePage: "非直连订单列表",
    };
    return formConfig;
  };
  //初始化表格
  initTableConfig = () => {
    const tableConfig = {
      tableKey: "unDirectConnectDeviceTable",
      tableColumns: [
        {
          name: "设备编号",
          key: "deviceId",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "地区",
          key: "areaName",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "设备类型",
          key: "typeName",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "设备型号",
          key: "modelNo",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "固件信息",
          key: "version",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "设备状态",
          key: "statusName",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "iccid卡号",
          key: "iccid",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "质保供应商", // '供应商',
          key: "tenceCompanyName",
          colType: "textCol",
          align: "left",
        },
        {
          name: "操作",
          key: "action",
          fix: "right",
          width: 320,
          colType: "action",
          actionMap: [
            useAuth("010803")
              ? {
                  type: "href",
                  actionName: "配置信息",
                  handler: (record) => {
                    console.log({ record });
                    this.setState({
                      seeParamsConfigVisible: true,
                      stubId: record.key,
                      devType: record.type,
                    });
                    // if (record.key.length != 11 || record.key.substr(0, 1) != "8") {
                    //   this.setState({
                    //     seeParamsConfigVisible: true,
                    //     stubId: record.key,
                    //     stubGroupName: record.stubGroupName,
                    //     devType: record.type,
                    //   });
                    // } else {
                    //   this.setState({
                    //     hpcSettingVisible: true,
                    //     stubId: record.key,
                    //   });
                    // }
                  },
                }
              : "",
            useAuth("010804")
              ? {
                  type: "href",
                  actionName: "状态日志",
                  handler: (record) => {
                    console.log({ record });
                    this.stubInfoData = record;
                    this.modalVisibleAction("statusLogVisible", true);
                  },
                }
              : "",
            useAuth("010805")
              ? {
                  type: "href",
                  actionName: "固件升级",
                  render: (record) => {
                    return record.statusName === "升级中" ? null : "固件升级";
                  },
                  handler: (record) => {
                    console.log({ record });
                    // if (record.key.length == 11 && record.key.substr(0, 1) == "8") {
                    //   this.stubInfoData = {
                    //     stubIds: [record.key],
                    //     stubIdsStr: record.key,
                    //   };
                    // } else {
                    //   this.stubInfoData = record;
                    // }
                    // this.setState({
                    //   updateStatus: null,
                    //   frameWorkUpdateVisible: true,
                    //   stubId: record.key,
                    //   frameType: record.updateType,
                    //   frameWork: record.frameWork,
                    //   smallVersion: record.smallVersion, // 增加小版本号
                    //   isBatch: null,
                    // });
                    this.stubInfoData = record;
                    this.modalVisibleAction("frameWorkUpdateVisible", true);
                  },
                }
              : "",
          ],
        },
      ],
      tableParam: {
        pageCount: 10,
      },
      tableInfo: {
        hasRow: !1, // 是否显示checkbox
      },
      dataApi: getUnDirectConnectDeviceApi,
      autoRefresh: !1, // 设置为true 直接加载grid数据
    };
    return tableConfig;
  };
  //刷新列表
  fetchApi = (param) => {
    console.log("fetchApi:", param);
    const newParam = {
      ...param,
      areaId: param.areaId ? param.areaId.join(",") : "",
    };
    console.log("fetchApi newParam:", newParam);
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "unDirectConnectDeviceTable", newParam);
    }
  };

  //导出
  exportData = (param) => {
    console.log("exportData:", param);
    const excelUrl = `${prefixFile}/exportOutStubInfo.do`;
    // param.locale = this.props.intl.locale;
    // if (param.updateType === this.yunwei.wz10) {
    //   param.updateType = "";
    // }
    // param.token = window.sessionStorage.getItem("token");
    // param.companyId = window.sessionStorage.getItem("companyId");
    // if (param.frameWork === this.yunwei.wz10) {
    //   param.frameWork = "";
    // }
    // // 城市id格式化
    // param.cityId =
    //   param.cityId === undefined
    //     ? ""
    //     : param.cityId
    //         .toString()
    //         .slice(param.cityId.toString().lastIndexOf(",") + 1, param.cityId.toString().length);

    // if (param.stubGroupName === this.queryStubName && !this.hasSearch) {
    //   param.stubGroupId = this.queryStubGroupId;
    // } else {
    //   param.stubGroupId = "";
    // }

    let params = "";
    Object.keys(param).forEach((key) => {
      if (param[key] !== undefined) {
        params += `${key}=${param[key]}&`;
      }
    });
    const ele = document.createElement("a");
    console.log("paramString", params);
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  //关闭modal弹窗
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  render() {
    return (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <GridTable config={this.state.tableConfig} />
        </div>

        <Modal
          title={"配置信息"}
          visible={this.state.seeParamsConfigVisible}
          footer={null}
          destroyOnClose
          width="1100px"
          onCancel={() => {
            this.modalVisibleAction("seeParamsConfigVisible", false);
          }}>
          <StubParamsConfig
            stubId={this.state.stubId}
            devType={this.state.devType}
            isUnDirect={true}
          />
        </Modal>

        <Modal
          title={"固件升级"}
          visible={this.state.frameWorkUpdateVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("frameWorkUpdateVisible", false);
          }}>
          <FrameWorkUpdate
            // updateFramType={() => {
            //   this.updateFramType();
            // }}
            frameWorkUpdateFunc={(reqId) => {
              this.fetchApi(this.state.tableParam);
              this.modalVisibleAction("frameWorkUpdateVisible", false);
              // this.setState({
              //   progressVisible: true,
              //   stubIds:
              //     this.state.stubId.length != 11 || this.state.stubId.substr(0, 1) != "8"
              //       ? null
              //       : this.state.stubId,
              //   reqId: reqId,
              // });
            }}
            errorHandler={() => {
              this.modalVisibleAction("frameWorkUpdateVisible", false);
              // this.setState({
              //   updateStatus: "error",
              //   progressVisible: true,
              // });
            }}
            // stubId={this.state.stubId}
            // frameWork={this.state.frameWork}
            // frameType={this.state.frameType}
            // smallVersion={this.state.smallVersion} // 增加小版本号
            // stubGroupName={this.state.stubGroupName}
            // devType={this.state.devType}
            onCancel={() => {
              this.modalVisibleAction("frameWorkUpdateVisible", false);
            }}
            stubInfoData={this.stubInfoData}
            isUnDirect={true}
          />
        </Modal>
        <Modal
          title="状态日志"
          visible={this.state.statusLogVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("statusLogVisible", false);
          }}>
          <StubStatusLog stubIdData={this.stubInfoData} isUnDirect={true} />
        </Modal>
      </div>
    );
  }
}

export default injectIntl(UnDirectConnectDevice);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/UnDirectConnectDevice.js